export interface ApiResponse<T> {
  data?: T;
  success: boolean;
  status?: number;
  totalPages?: number;
  totalCount?: number;
  pageNumber?: number;
  error?: {
    message: string;
    status?: number;
    /** Machine readable reason sent by the service, when it sends one. */
    code?: string;
    /** Minutes to wait before trying again, sent with a 429 `login_locked`. */
    retryAfterMinutes?: number;
    raw?: unknown;
  };
}
